var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.4 6.254 8.02 7.79a.54.54 0 0 1-.84 0 .697.697 0 0 1 0-.935l2.4-2.671c.03-.034.06-.05.09-.067a.3.3 0 0 0 .09-.067c.18-.067.36-.067.48 0 .06 0 .12.067.18.134l2.4 2.67c.24.268.24.669 0 .936a.52.52 0 0 1-.42.2.52.52 0 0 1-.42-.2L10.6 6.254v6.078c0 .4-.24.668-.6.668s-.6-.267-.6-.668zM16 14V9.667c0-.4-.267-.667-.667-.667s-.666.267-.666.667V14c0 .4-.267.667-.667.667H6c-.4 0-.667-.267-.667-.667V9.667c0-.4-.266-.667-.666-.667S4 9.267 4 9.667V14c0 1.133.867 2 2 2h8c1.133 0 2-.867 2-2",
  clipRule: "evenodd"
})));
export default SvgShare;